import axios from 'axios';
var moment = require('moment');
//Get current user(me) from token in localStorage
export const ME_FROM_TOKEN = 'ME_FROM_TOKEN';
export const ME_FROM_TOKEN_SUCCESS = 'ME_FROM_TOKEN_SUCCESS';
export const ME_FROM_TOKEN_FAILURE = 'ME_FROM_TOKEN_FAILURE';
export const RESET_TOKEN = 'RESET_TOKEN';

//Sign Up User
export const SIGNUP_USER = 'SIGNUP_USER';
export const SIGNUP_USER_SUCCESS = 'SIGNUP_USER_SUCCESS';
export const SIGNUP_USER_FAILURE = 'SIGNUP_USER_FAILURE';
export const RESET_USER = 'RESET_USER';

//Sign Up Subscriber
export const SUBMIT_FORM = 'SUBMIT_FORM';
export const SET_SUBSCRIPTION_EMAIL = 'SET_SUBSCRIPTION_EMAIL';
export const STOP_SUBMIT_FORM = 'STOP_SUBMIT_FORM';
export const PROCESSED_SUBSCRIBER = 'PROCESSED_SUBSCRIBER';
export const LOAD_PRODUCT = 'LOAD_PRODUCT';
export const ACCEPT_CONTRACT = 'ACCEPT_CONTRACT';

export const SIGNIN_USER_SUCCESS = 'SIGNIN_USER_SUCCESS';
export const SIGNIN_USER_FAILURE = 'SIGNIN_USER_FAILURE';

//Steps by providers
export const LOAD_CBU = 'LOAD_CBU';

export const SAVE_CHECK = 'SAVE_CHECK'

export const SAVE_CHECK_DETAIL = 'SAVE_CHECK_DETAIL'

//Sms Validation
export const VERIFY_CODE = 'VERIFY_CODE';

//Address Form
export const SAVE_ADDRESS = 'SAVE_ADDRESS';

export const MZA_ACTIVE = 'MZA_ACTIVE';

export const ELECTRONIC_WALLET ='ELECTRONIC_WALLET'

export const CONFIRM_ADDRESS = 'CONFIRM_ADDRESS'

export const CONFIRM_PRY_ADDRESS = 'CONFIRM_PRY_ADDRESS'

export const SAVE_JOB_INFO = 'SAVE_JOB_INFO';

export const SAVE_EMAIL = 'SAVE_EMAIL';

export const SAVE_AMOUNT = 'SAVE_AMOUNT';

export const ACCEPT_AMOUNT = 'ACCEPT_AMOUNT';

export const UPDATE_DOCUMENT_STEP = 'UPDATE_DOCUMENT_STEP';

export const LOAN_REASON = 'LOAN_REASON';

export const SAVE_LOAN_DESCRIPTION = 'SAVE_LOAN_DESCRIPTION';

export const SET_PRY_ROL = 'SET_PRY_ROL';

export const ACCEPT_STARTUP = 'ACCEPT_STARTUP';

export const HAS_ATTORNEY = 'HAS_ATTORNEY';

export const ACCEPT_LOANLINE = 'ACCEPT_LOANLINE';

export const SAVE_LASTSALES = 'SAVE_LASTSALES';

export const SAVE_HASPROPERTY = 'SAVE_HASPROPERTY';

export const CHECK_AMOUNT = 'CHECK_AMOUNT';

export const CHECK_DPJ = 'CHECK_DPJ';

export const SAVE_DPJ = 'SAVE_DPJ';

export const SAVE_PERSONAL_INFO = 'SAVE_PERSONAL_INFO';

export const SAVE_LOAN_TYPE = 'SAVE_LOAN_TYPE';

export const SAVE_COMPANY_TYPE = 'SAVE_COMPANY_TYPE';

export const SAVE_LOCAL_COMPANY = 'SAVE_LOCAL_COMPANY';

export const SAVE_ADDITIONAL_PERSONAL_INFO = 'SAVE_ADDITIONAL_PERSONAL_INFO';

export const SAVE_SERVICE_INFO = 'SAVE_SERVICE_INFO';

export const SAVE_CREDIT_CARD = 'SAVE_CREDIT_CARD';

export const SAVE_INCOMES = 'SAVE_INCOMES';

export const SAVE_DEPOSIT = 'SAVE_DEPOSIT';

export const SAVE_FILES = 'SAVE_FILES';

export const SAVE_PRYADDRESS = 'SAVE_PRYADDRESS';

//validate email, if success, then load user and login
export const VALIDATE_EMAIL = 'VALIDATE_EMAIL';
export const VALIDATE_EMAIL_SUCCESS = 'VALIDATE_EMAIL_SUCCESS';
export const VALIDATE_EMAIL_FAILURE = 'VALIDATE_EMAIL_FAILURE';

//called when email is updated in profile to update main user's email state
export const UPDATE_USER_EMAIL = 'UPDATE_USER_EMAIL';

//log out user
export const LOGOUT_USER = 'LOGOUT_USER';

export const GET_NEXT_STEP = 'GET_NEXT_STEP';

export const VALIDATE_MEMBERS = 'VALIDATE_MEMBERS'

export const VALIDATE_GUARANTOR = 'VALIDATE_GUARANTOR'

export const SAVE_ATTORNEY = 'SAVE_ATTORNEY'

export const VALIDATE_VINEYARDS = 'VALIDATE_VINEYARDS'

export const SET_VINEYARD_TYPES = 'SET_VINEYARD_TYPES'

export const LOADING_WARRANTY = 'LOADING_WARRANTY'

export const LOAD_CA_WARRANTY = 'LOAD_CA_WARRANTY'

export const GUARANTOR = 'GUARANTOR'

export const LOAD_SURETY = 'LOAD_SURETY'

export const LOADING_GENERAL_WARRANTY = 'LOADING_GENERAL_WARRANTY'

export const VALIDATE_WINECELLAR = 'VALIDATE_WINECELLAR'


const ROOT_URL = process.env.API_URL;

export function meFromTokenSuccess(currentUser) {
    return {
        type: ME_FROM_TOKEN_SUCCESS,
        payload: currentUser
    };
}

export function meFromTokenFailure(error) {
    return {
        type: ME_FROM_TOKEN_FAILURE,
        payload: error
    };
}

export function resetToken() {//used for logout
    return {
        type: RESET_TOKEN
    };
}

export function resetUser() {
    return {
        type: RESET_USER,
    };
}

export function submitForm() {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
    return {
        type: SUBMIT_FORM,
        payload: sleep(1)
    };
}

export function setSubscriptionEmail(formValues, jwt_token) {
    var headers = {
        'Content-Type': 'application/json'
    }

    const request = axios.put(`${ROOT_URL}/subscribers/by_jwt/` + sessionStorage.getItem('jwtAuthToken'), formValues, headers);

    return {
        type: SET_SUBSCRIPTION_EMAIL,
        payload: request
    };
}

export function stopSubmitForm() {

    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
    return {
        type: STOP_SUBMIT_FORM,
        payload: sleep(1)
    };
}

export function processSubscriber(formValues) {
    var headers = {
        'Content-Type': 'application/json'
    }

    const request = axios.post(`${ROOT_URL}/subscribers/process`, formValues, headers);

    return {
        type: PROCESSED_SUBSCRIBER,
        payload: request
    };
}

export function loadProduct(product) {
    var config = {
        headers:
        {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    const request = axios.put(`${ROOT_URL}/leads/product`, product, config);

    return {
        type: LOAD_PRODUCT,
        payload: request
    };
}

export function loadCbu(cbu) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    const request = axios.put(`${ROOT_URL}/leads/cbu`, cbu, config);

    return {
        type: LOAD_CBU,
        payload: request
    };
}

export function verifyCode(sms_code) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };
    var data = {
        'code': sms_code
    };

    const request = axios.post(`${ROOT_URL}/sms/verify_code`, data, config);

    return {
        type: VERIFY_CODE,
        payload: request
    };
}

export function validateMembers(values) {
    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    const request = axios.put(`${ROOT_URL}/subscribers/members`, values, config);

    return {
        type: VALIDATE_MEMBERS,
        payload: request
    };
}

export function validateGuarantor(values) {
    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    const request = axios.put(`${ROOT_URL}/subscribers/guarantor`, values, config);

    return {
        type: VALIDATE_GUARANTOR,
        payload: request
    };
}

export function saveAttorney(values) {
    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    const request = axios.put(`${ROOT_URL}/subscribers/attorney_info`, values, config);

    return {
        type: SAVE_ATTORNEY,
        payload: request
    };
}

export function validateVineyards(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };


    const request = axios.put(`${ROOT_URL}/subscribers/vineyards`, values, config);

    return {
        type: VALIDATE_VINEYARDS,
        payload: request
    };
}

export function setVineyardTypes(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };


    const request = axios.put(`${ROOT_URL}/subscribers/vineyard_types`, values, config);

    return {
        type: SET_VINEYARD_TYPES,
        payload: request
    };
}

export function updateDocumentStep() {
    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    const request = axios.post(`${ROOT_URL}/leads/documents`, {}, config);

    return {
        type: UPDATE_DOCUMENT_STEP,
        payload: request
    };
}

export function loadWarranty(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    const request = axios.put(`${ROOT_URL}/subscribers/warranty`, values, config);

    return {
        type: LOADING_WARRANTY,
        payload: request
    };
}

export function loadCAWarranty(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    const request = axios.put(`${ROOT_URL}/subscribers/ca_warranty`, values, config);

    return {
        type: LOAD_CA_WARRANTY,
        payload: request
    };
}

export function loadGeneralWarranty(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    const request = axios.put(`${ROOT_URL}/subscribers/general_warranty`, values, config);

    return {
        type: LOADING_GENERAL_WARRANTY,
        payload: request
    };
}

export function loadGuarantor(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    const request = axios.put(`${ROOT_URL}/subscribers/guarantor_type`, values, config);

    return {
        type: GUARANTOR,
        payload: request
    };
}

export function loadSurety(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    const request = axios.put(`${ROOT_URL}/subscribers/surety`, values, config);

    return {
        type: LOAD_SURETY,
        payload: request
    };
}

export function validateWinecellar(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    const request = axios.put(`${ROOT_URL}/subscribers/winecellar_info`, values, config);

    return {
        type: VALIDATE_WINECELLAR,
        payload: request
    }
}

export function acceptContract(values) {
    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    }
    const { contract_accepted } = values

    const request = axios.put(`${ROOT_URL}/leads/contracts/${values.endpoint}`, { contract_accepted }, config);

    return {
        type: ACCEPT_CONTRACT,
        payload: request
    };
}

export function signInUserSuccess(user) {
  return {
    type: SIGNIN_USER_SUCCESS,
    payload: user
  };
}

export function signInUserFailure(error) {
  return {
    type: SIGNIN_USER_FAILURE,
    payload: error
  };
}

export function logoutUser() {
  return {
    type: LOGOUT_USER
  };
}

export function updateUserEmail(email) {
  return {
    type: UPDATE_USER_EMAIL,
    payload: email
  };
}

export function validateEmail() {
  return {
    type: VALIDATE_EMAIL
  }
}

export function getNextStep() {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    const request = axios.get(`${ROOT_URL}/leads/steps/next`, config);
    return {
        type: GET_NEXT_STEP,
        payload: request
    };
}

export function saveAddress(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var data = {
        'address_street': values.address_street,
        'form_locality': values.form_locality,
        'state_id': values.state_id,
        'zip_code': values.zip_code,
        'address_description': values.address_description ? values.address_description : '',
        'address_building': values.building ? values.building : '',
        'address_flat': values.flat ? values.flat : '',
        'address_department': values.department ? values.department : '',
        'address_quarter': values.quarter ? values.quarter : '',
        'address_apple': values.apple ? values.apple : '',
    };

    const request = axios.put(`${ROOT_URL}/subscribers/address`, data, config);

    return {
        type: SAVE_ADDRESS,
        payload: request
    };
}

export function saveMzaActive(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var data = {
        'has_mza_active': values.has_mza_active,
        'mza_active_ticket': values.mza_active_ticket ? values.mza_active_ticket : '',
    };

    const request = axios.put(`${ROOT_URL}/subscribers/mza_active`, data, config);

    return {
        type: SAVE_ADDRESS,
        payload: request
    };
}

export function saveElectronicWallet(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var data = {
        'electronic_wallet': values.electronic_wallet,
    };

    const request = axios.put(`${ROOT_URL}/subscribers/electronic_wallet`, data, config);

    return {
        type: ELECTRONIC_WALLET,
        payload: request
    };
}

export function savePryAddress(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var data = {
        'pry_address_street': values.pry_address_street,
        'pry_form_locality': values.pry_form_locality,
        'pry_state_id': values.state_id,
        'pry_zip_code': values.pry_zip_code,
        'cadastral_nomenclature': values.cadastral_nomenclature ? values.cadastral_nomenclature : '',
        'pry_address_description': values.pry_address_description ? values.pry_address_description : '',
        'pry_address_building': values.pry_building ? values.pry_building : '',
        'pry_address_flat': values.pry_flat ? values.pry_flat : '',
        'pry_address_department': values.pry_department ? values.pry_department : '',
        'pry_address_quarter': values.pry_quarter ? values.pry_quarter : '',
        'pry_address_apple': values.pry_apple ? values.pry_apple : ''
    };

    const request = axios.put(`${ROOT_URL}/subscribers/pry_address`, data, config);

    return {
        type: SAVE_PRYADDRESS,
        payload: request
    };
}

export function saveConfirmAddress(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var data = {
        'address_confirm': values.address_confirm
    };

    const request = axios.put(`${ROOT_URL}/subscribers/address_confirm`, data, config);

    return {
        type: CONFIRM_ADDRESS,
        payload: request
    };
}

export function saveConfirmPryAddress(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var data = {
        'address_confirm_pry': values.address_confirm_pry
    };

    const request = axios.put(`${ROOT_URL}/subscribers/address_confirm_pry`, data, config);

    return {
        type: CONFIRM_PRY_ADDRESS,
        payload: request
    };
}

export function saveJobInfo(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var now = moment(new Date());
    var initDate = now.subtract(values.init_date, 'months').subtract(1, 'days');

    var data = {
        'vehicle': values.vehicle,
        'job_type': values.job_type,
        'init_date': initDate.format("YYYY-MM-DD"),
        'wage_garnishment': values.wage_garnishment
    };

    const request = axios.put(`${ROOT_URL}/subscribers/job_info`, data, config);

    return {
        type: SAVE_JOB_INFO,
        payload: request
    };
}

export function saveEmail(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };
    var data = {
        'email': values.email,
    };

    const request = axios.put(`${ROOT_URL}/subscribers/email`, data, config);

    return {
        type: SAVE_EMAIL,
        payload: request
    };
}

export function saveAmount(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };
    var data = {
        'requested_amount': values.requested_amount,
    };

    const request = axios.put(`${ROOT_URL}/subscribers/amount`, data, config);

    return {
        type: SAVE_AMOUNT,
        payload: request
    };
}

export function saveLoanReason(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };
    var data = {
        'loan_reason': values.loan_reason,
        'loan_activity': values.loan_activity
    };

    const request = axios.put(`${ROOT_URL}/subscribers/loan_reason`, data, config);

    return {
        type: LOAN_REASON,
        payload: request
    };
}

export function saveLoanDescriptionForm(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };
    var data = {
        'requested_amount': values.requested_amount,
    };

    const request = axios.put(`${ROOT_URL}/subscribers/loan_description`, data, config);

    return {
        type: SAVE_LOAN_DESCRIPTION,
        payload: request
    };
}

export function setPryRol(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };
    var data = {
        'pry_rol': values.pry_rol,
    };

    const request = axios.put(`${ROOT_URL}/subscribers/pry_rol`, data, config);

    return {
        type: SET_PRY_ROL,
        payload: request
    };
}

export function saveDpj(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };
    var data = {
        'dpj_number': values.dpj_number,
    };

    const request = axios.put(`${ROOT_URL}/subscribers/dpj_number`, data, config);

    return {
        type: SAVE_DPJ,
        payload: request
    };
}

export function savePersonalInfo(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var data = {
        'marital_status': values.marital_status,
        'couple_has_employment': values.couple_has_employment,
        'people_in_house': values.people_in_house,
        'house_condition': values.house_condition,
        'breadwinner': values.breadwinner,
        'rental_price': values.rental_price,
        'bathrooms': values.bathrooms,
        'bedrooms': values.bedrooms,
        'children': values.children,
        'independent_children': (values.children - values.dependent_children).toString(),
        'children_in_school': values.children_in_school,
        'children_institution_type': values.children_institution_type
    };

    const request = axios.put(`${ROOT_URL}/subscribers/personal_info`, data, config);

    return {
        type: SAVE_PERSONAL_INFO,
        payload: request
    };
}

export function saveLoanType(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var data = {
        'loan_type': values.loan_type,
    };

    const request = axios.put(`${ROOT_URL}/subscribers/loan_type`, data, config);

    return {
        type: SAVE_LOAN_TYPE,
        payload: request
    };
}


export function saveCompanyType(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var data = {
        'company_sector': values.company_sector,
        'company_category': values.company_category,
    };

    const request = axios.put(`${ROOT_URL}/subscribers/company_type`, data, config);

    return {
        type: SAVE_COMPANY_TYPE,
        payload: request
    };
}

export function saveLocalCompany(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var data = {
        'local_company': values.local_company,
    };

    const request = axios.put(`${ROOT_URL}/subscribers/check_address`, data, config);

    return {
        type: SAVE_LOCAL_COMPANY,
        payload: request
    };
}

export function acceptAmount(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var data = {
        'accept_amount': values.accept_amount,
    };

    const request = axios.put(`${ROOT_URL}/subscribers/available_amount`, data, config);

    return {
        type: ACCEPT_AMOUNT,
        payload: request
    };
}

export function acceptStartup(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var data = {
        'startup': values.startup,
    };

    const request = axios.put(`${ROOT_URL}/subscribers/startup`, data, config);

    return {
        type: ACCEPT_STARTUP,
        payload: request
    };
}

export function saveCheck(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var data = {
        'check_transmitter': values.check_transmitter,
        'check_recipient': values.check_recipient
    };

    const request = axios.put(`${ROOT_URL}/subscribers/check_transmitter`, data, config);

    return {
        type: SAVE_CHECK,
        payload: request
    };
}

export function saveCheckDetail(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var data = {
        'check_amount': Number(values.check_amount),
        'check_date': values.check_date,
        'check_type': values.check_type
    };

    const request = axios.put(`${ROOT_URL}/subscribers/check_detail`, data, config);

    return {
        type: SAVE_CHECK_DETAIL,
        payload: request
    };
}

export function HasAttorney(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var data = {
        'has_attorney': values.has_attorney,
    };

    const request = axios.put(`${ROOT_URL}/subscribers/attorney`, data, config);

    return {
        type: HAS_ATTORNEY,
        payload: request
    };
}

export function hasLoanLine(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var data = {
        'loan_line': values.loan_line,
    };

    const request = axios.put(`${ROOT_URL}/subscribers/loan_line`, data, config);

    return {
        type: ACCEPT_LOANLINE,
        payload: request
    };
}

export function infoLastSales(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var data = {
        'last_sales': values.last_sales,
        'has_property': values.has_property
    };

    const request = axios.put(`${ROOT_URL}/subscribers/last_sales`, data, config);

    return {
        type: SAVE_LASTSALES,
        payload: request
    };
}

export function saveHasProperty(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var data = {
        'has_property': values.has_property_title
    };

    const request = axios.put(`${ROOT_URL}/subscribers/has_property`, data, config);

    return {
        type: SAVE_HASPROPERTY,
        payload: request
    };
}

export function checkDpj(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var data = {
        'dpj': values.dpj,
    };

    const request = axios.put(`${ROOT_URL}/subscribers/check_dpj_number`, data, config);

    return {
        type: CHECK_DPJ,
        payload: request
    };
}


export function saveAdditionalPersonalInfo(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var data = {
        'work_file_code': values.work_file_code,
        'reason_financial_aid': values.reason_financial_aid,
        'real_address_state_id': values.real_address_state_id,
        'real_address_locality': values.real_address_locality,
        'real_address_street': values.real_address_street,
        'real_address_zip_code': values.real_address_zip_code,
        'work_address_state_id': values.work_address_state_id,
        'work_address_locality': values.work_address_locality,
        'work_address_street': values.work_address_street,
        'work_address_zip_code': values.work_address_zip_code
    };

    const request = axios.put(`${ROOT_URL}/subscribers/additional_personal_info`, data, config);

    return {
        type: SAVE_ADDITIONAL_PERSONAL_INFO,
        payload: request
    };
}

export function saveServiceInfo(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var data = {
        'vehicle': values.vehicle,
        'car_insurance': values.car_insurance,
        'life_insurance': values.life_insurance,
        'house_insurance': values.house_insurance,
        'services': values.services,
        'tv_service': values.tv_service,
        'internet_service': values.internet_service
    };

    const request = axios.put(`${ROOT_URL}/subscribers/service_info`, data, config);

    return {
        type: SAVE_SERVICE_INFO,
        payload: request
    };
}

export function saveCreditCard(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var data = {
        'last_digits_credit_card': values.last_digits_credit_card
    };

    const request = axios.put(`${ROOT_URL}/subscribers/credit_card`, data, config);

    return {
        type: SAVE_CREDIT_CARD,
        payload: request
    };
}

export function saveIncomes(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    /*var data = {
        'leasing_type': values.leasing_type,
        'monotributo_category': values.monotributo_category,
        'monthly_costs': values.monthly_costs,
        'number_of_employees': values.number_of_employees,
        'self_employment_incomes': values.self_employment_incomes.map((income) => { return {...income, date: income.date.format("YYYY-MM-DD")}})
    };*/
    let data = {...values}

    var now = moment(new Date());
    var baseDate = now.subtract(1, 'month').startOf('month');

    if('self_employment_incomes' in values){
        data = {...values, self_employment_incomes: values.self_employment_incomes.map((income) => { return {...income, income_date: income.income_date.format("YYYY-MM-DD")}})}
    }

    if('check_stubs' in values){
        data = {...values, check_stubs: values.check_stubs.map((check_stub) => { return {...check_stub, remuneration_date: baseDate.clone().add(check_stub.remuneration_date, 'days').format("YYYY-MM-DD")}})}
    }


    const request = axios.put(`${ROOT_URL}/subscribers/incomes`, data, config);

    return {
        type: SAVE_INCOMES,
        payload: request
    };
}

export function saveDeposit(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var data = {...values};


    const request = axios.put(`${ROOT_URL}/subscribers/deposit`, data, config);

    return {
        type: SAVE_DEPOSIT,
        payload: request
    };
}

export function saveFiles(values) {

    var config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
        }
    };

    var data = {
        'document_number_front': values.document_number_front,
        'document_number_back': values.document_number_back,
        'tax': values.tax,
        'cbu_document': values.cbu_document,
        'last_pay_check': values.last_pay_check,
    };

    const request = axios.put(`${ROOT_URL}/subscribers/upload`, data, config);
    return {
        type: SAVE_FILES,
        payload: request
    };
}



/** WEBPACK FOOTER **
 ** ./src/actions/users.js
 **/